import RhfDocumentsUpload, {
    type RhfDocumentsUploadRef,
} from "@/components/RhfDocumentsUpload.tsx";
import { Box, Typography } from "@mui/material";
import { File } from "lucide-react";
import type React from "react";

type Props = {
    caseUUID: string;
    documentsUploadRef: React.RefObject<RhfDocumentsUploadRef>;
};

const AddDocumentsSection: React.FC<Props> = ({ caseUUID, documentsUploadRef }: Props) => {
    return (
        <Box
            sx={{
                mt: 1,
                p: 2,
                backgroundColor: "#fafafa",
                borderRadius: 1,
                border: (theme) => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                }}
            >
                <File size={20} />
                <Typography
                    sx={{
                        fontSize: "1rem",
                        fontWeight: 500,
                        color: "text.primary",
                    }}
                >
                    Attachments
                </Typography>
            </Box>
            <RhfDocumentsUpload ref={documentsUploadRef} caseUUID={caseUUID} />
        </Box>
    );
};

export default AddDocumentsSection;
